module.exports = __webpack_public_path__ + "media/images/socials/twitch-1f36f0f9e9da24d3c2edc8fc0445cc8e.png";